(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name wbAuth.controller:LogoutCtrl
   *
   * @description
   *
   */
  angular
    .module('wbAuth')
    .controller('LogoutCtrl', LogoutCtrl);

  function LogoutCtrl(Auth, $state) {
    Auth.logout();
    $state.go('login');
  }
}());
